<template>
    <div class="bg_main"  v-resize="onResize" v-if="hasPagination">
        
        
        <!-- <v-row>
            <v-col cols="6" sm="6" md="6" lg="3" v-for="(card, index) in cards" :key="card.value">
                <v-card
                    class="mx-auto dash_cards"
                    :class="'bg_home_card_' + (index + 1)"
                    max-width="344"
                    outlined
                    link
                    @click="filterProceduresList(card.id)"
                >
                    <v-list-item three-line>
                        <v-avatar
                            v-bind:color="'bg_home_card_' + (index + 1) + '_avatar'"
                            size="62"
                        >
                            <img
                                class="ico_card"
                                :src="$renderImageFromAssets('icon_home_card_' + (index + 1))"
                            />
                        </v-avatar>

                        <v-list-item-content class="right-auto">
                            <v-card-subtitle class="pb-0 text-uppercase">
                                <span class="font-weight-bold">{{ card.title }} </span>
                                <span>{{ getCountNumber(card.status) }}</span>
                            </v-card-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <div
                        class="sub_text_card pb-2"
                        :class="'bg_home_card_' + (index + 1) + '_title'"
                    >
                        <v-icon color="white">fas fa-sort-amount-down-alt</v-icon>
                    </div>
                </v-card>
            </v-col>
        </v-row>  -->

        <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
        <v-row class="" v-if="!isMobile">
            <v-col cols="12" >
                <v-card>
                    <v-card-title  class="text-pantone text-family font-weight-bold">
                        <template v-if="proceduresStore.filterStatus === 1">
                            Trámites pendientes
                        </template>
                        <template v-else-if="proceduresStore.filterStatus === 5">
                            Trámites en proceso de revisión y/o validación
                        </template>
                        <template v-else-if="proceduresStore.filterStatus === 3">
                            Trámites cancelados
                        </template>
                        <template v-else-if="proceduresStore.filterStatus === 2">
                            Trámites completados
                        </template>
                        <!-- <template v-else-if="proceduresStore.filterStatus === 5">
                            Trámites en proceso de revisión y/o validación
                        </template> -->
                        <template v-else>Todos los trámites del ciudadano</template>
                    </v-card-title>
                    <div class="forma-titulo"></div>
                    <v-divider class="mx-4"></v-divider>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="grey--text text--darken-1 text-family">ID</th>
                                <th class="grey--text text--darken-1 text-family">NOMBRE DEL TRÁMITE</th>
                                <th class="grey--text text--darken-1 text-family">ETAPA ACTUAL</th>
                                <th class="grey--text text--darken-1 text-family">FECHA Actualización</th>
                                <th class="grey--text text--darken-1 text-family">ESTATUS</th>
                                <th class="grey--text text--darken-1 text-family">ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="procedure in procedures" :key="procedure.id" class="py-4 " style="height:4rem">
                            <td class="text-family">{{ procedure.id }}</td>
                            <td class="text-family">{{ procedure.process.name }}</td>
                            <td class="text-family" style="max-width:250px;width: 250px">{{procedure.stages.length > 0 ? procedure.stages[0].task.name : "" }}</td>
                            <td class="text-family" style="max-width:100px;width:100px">{{procedure.stages.length > 0? procedure.stages[0].created_at: "" }}</td>
                            <td style="max-width:50px;width:50px">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-img v-if="procedure.status.male_label == 'Pendiente'" 
                                            alt="pendiente"
                                            class="ml-0"
                                            contain
                                            :src="$renderImageFromAssets('estatus_pending')"
                                            transition="scale-transition"
                                            width="30"
                                            align=""
                                            v-on="on"
                                            v-bind="attrs"
                                        />
                                        <v-img
                                            v-if="procedure.status.male_label == 'Terminado' " 
                                            alt="Terminado"
                                            class="ml-0"
                                            contain
                                            :src="$renderImageFromAssets('estatus_finished')"
                                            transition="scale-transition"
                                            width="30"
                                            align=""
                                            v-on="on"
                                            v-bind="attrs"
                                        />
                                        <v-img 
                                            v-if="procedure.status.male_label == 'En proceso' " 
                                            alt="Proceso"
                                            class="ml-0"
                                            contain
                                            :src="$renderImageFromAssets('estatus_on_process')"
                                            transition="scale-transition"
                                            width="30"
                                            align=""
                                            v-on="on"
                                            v-bind="attrs"
                                        />
                                        <v-img 
                                            v-if="procedure.status.male_label == 'Cancelado' " 
                                            alt="Proceso"
                                            class="ml-0"
                                            contain
                                            :src="$renderImageFromAssets('estatus_canceled')"
                                            transition="scale-transition"
                                            width="30"
                                            align=""
                                            v-on="on"
                                            v-bind="attrs"
                                        />
                                    </template>     
                                    <span>{{ procedure.status.male_label }}</span>      
                                </v-tooltip>
                            </td>
                            <td class="d-flex align-center " style="min-height:100px">
                             
                                <router-link
                                    v-if="procedure.status.name === 'active'"
                                    class="text-decoration-none"
                                    :to="{name: 'procedure_continue',params: { stageId: procedure.stages[0].id }}"
                                >
                                    <v-btn tile class="success_border text-family btn-verde" small>
                                        Continuar trámite
                                    </v-btn>
                                </router-link>

                                <v-menu
                                    v-if="procedure.status.name === 'finished'"
                                    offset-y
                                    rounded="0"
                                    origin="center center"
                                    transition="scale-transition"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            class="success_border btn-azul text-family"
                                            v-bind="attrs"
                                            v-on="on"
                                            tile
                                            small
                                        >
                                            Ver historial
                                            <v-icon small right>fas fa-chevron-down</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <template v-for="stage in procedure.stages">
                                            <v-list-item
                                                v-if="stage.status.name === 'finished' && stage.user_assigned != null &&
                                                    stage.user_assigned.id == accountStore.user.id" :key="stage.id"
                                            >
                                                <v-list-item-title>
                                                    <router-link
                                                        :to="{name: 'procedure_view',params: { stageId: stage.id }}"
                                                        class="text-decoration-none text-family font-size-sm"
                                                    >
                                                        {{ stage.task.name }}
                                                    </router-link>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-menu>
                                
                                 <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn tile icon class="success_border text-family transparent" small v-on="on" v-bind="attrs"
                                            @click="showProcedureStages(procedure.stages)"
                                        >
                                            <img class="ico_item_action"  :src="$renderImageFromAssets('estatus_see_more')"/>
                                        </v-btn>
                                    </template>
                                    <span> Ver Proceso </span>      
                                 </v-tooltip>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>

                    <div class="text-center pa-2 pb-4">
                        <v-pagination
                            class="custom_pag"
                            v-if="hasPagination"
                            v-model="page"
                            :length="paginator.total_pages"
                            total-visible="10"
                            @input="getProceduresList"
                        ></v-pagination>
                    </div>
                </v-card>
            </v-col>
        </v-row> 
        

        <v-card class="card-orders-list" v-if="isMobile"> 
             <v-card-title  class=" text-family ml-3 py-3 font-weight-bold text" style="word-break: break-word;">
                        <template v-if="proceduresStore.filterStatus === 1">Trámites pendientes</template>
                        <template v-else-if="proceduresStore.filterStatus === 2">Trámites completados y/o finalizados</template>
                        <template v-else-if="proceduresStore.filterStatus === 3">Trámites cancelados</template>
                        <template v-else-if="proceduresStore.filterStatus === 5">Trámites en proceso de revisión y/o validación</template>
                        <template v-else>Tus trámites</template>
                </v-card-title>
                <div class="forma-titulo"></div>
                <v-divider class="mx-4"></v-divider>

            <v-list three-line class="pt-0 hidden-md-and-up " >
                <template v-for="(procedure, index) in procedures" >

                    <v-divider  class="mx-5" :key="'o'+index" v-if="index > 0"></v-divider>

                    <v-list-item @click="function (){}" :key="'mp'+index"  class="d-flex align-center" style="margin: 5px 0px" :to="{name: 'procedure_continue',params: { stageId: procedure.stages[0].id }}">

                        <v-list-item-avatar class="ml-5" style="width:60px !important;height:60px !important" v-bind:color="pantoneLight" >
                            <v-img
                            :src="procedure.process.icon"
                            >

                            </v-img>
                        </v-list-item-avatar>

                        <v-list-item-content class="ml-2"> 
                            <v-list-item-title > 
                                {{   procedure.process.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle  style="width:100%" class="d-flex">
                                {{procedure.id}}- {{procedure.stages[0].task.name}} <v-badge class=" mr-5 d-flex justify-end flex-fill"  inline  :color="setColorBadge(procedure.status.id)"></v-badge>
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <!-- <v-list-item-action  class="d-flex align-center "> -->
                            <v-btn  class="d-flex align-center mr-2" icon @click="goToEditOrder(procedure.id)">
                                <v-icon :color="pantoneBlack">fas fa-chevron-right</v-icon>
                            </v-btn>
                        <!-- </v-list-item-action> -->

                    </v-list-item>
                </template>
            </v-list>
            <div class="text-center pa-2 pb-4">
                <v-pagination
                    class="custom_pag"
                    v-if="hasPagination"
                    v-model="page"
                    :length="paginator.total_pages"
                    total-visible="10"
                    @input="getProceduresList"
                ></v-pagination>
            </div>
        </v-card>


        <!-- END TABLE FOR PROCESSES   -->
        <procedure-stages show-modal=""></procedure-stages>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import ProcedureStages from "../components/dashboard/ProcedureStages";
import {
    getProcedureStatusColor,
    getProcedureStatusIcon,
} from "@/assets/assets_utils";
import router from "@/router";
import { procedureListRequest } from "bestgob-core/api/models";

export default {
    name: "Dashboard",
    components: { ProcedureStages },
    computed: {
        ...mapState({
            accountStore: (state) => state.account,
            proceduresStore: (state) => state.procedures,
        }),
        ...mapGetters("procedures", ["hasPagination", "paginator", "procedures"]),
    },
    data() {
        return {
            pantone: '#B08C55',
            pantoneLight: '#fff5d3',
            pantoneBlack: '#15212F',
            FILTER_STATUS_ACTIVE: 1,
            FILTER_STATUS_FINISHED: 2,
            FILTER_STATUS_CANCELED: 3,
            FILTER_STATUS_DELETED: 4,
            FILTER_STATUS_IN_PROCESS: 5,

            cards: [
                {
                    id: 1,
                    status: "active",
                    title: "Pendientes",
                    color: "bg_home_card_1",
                    css: "card_1",
                },
                {
                    id: 5,
                    status: "in-process",
                    title: "En Proceso",
                    color: "bg_home_card_2",
                    css: "card_2",
                },
                {
                    id: 3,
                    status: "canceled",
                    title: "Cancelados",
                    color: "bg_home_card_3",
                    css: "card_3",
                },
                {
                    id: 2,
                    status: "finished",
                    title: "Completados",
                    color: "bg_home_card_4",
                    css: "card_4",
                },
            ],
            page: 1,
            pageLimit: 10,
            procedureStages: [],
            showProcedureStagesModal: false,
            fab: false,
            isMobile: false,
            search: "",
        };
    },

    created() {
        this.$gtag.event("home", { method: "Google" });
    },

    mounted() {
        this.clearProcedures();
        this.getProceduresList();
        this.countProcedures();
    },

    methods: {
        ...mapActions("procedures", [
            "getProceduresByUser",
            "clearProcedures",
            "getProceduresCount",
        ]),
        ...mapMutations("procedures", ["showList"]),

        filterProcedures() {
            let filter = this.procedures.filter((procedure) =>
                procedure.process.name.toLowerCase().includes(this.search.toLowerCase())
            );
            this.showList(filter);
        },

        setColorBadge(status){
            var  color;
            status == 1 ? color = 'blue' : ''
            status == 2 ? color = 'green' : ''
            status == 3 ? color = 'red' : ''
            status == 4 ? color = 'grey' : ''
            status == 5 ? color = 'yellow' : ''
            return color
        },

        getProceduresList() {
            let request = procedureListRequest();
            request.userId = this.accountStore.user.id;
            request.status = this.proceduresStore.filterStatus;
            request.limit = this.proceduresStore.pageLimit;
            request.page = this.page;
            request.searchTerm = this.search;

            this.getProceduresByUser(request);
        },

        countProcedures() {
            this.getProceduresCount();
        },

        showProcedureStages(stages) {
            this.showProcedureStagesModal = true;
            this.procedureStages = stages;
        },

        getCountNumber(status) {
            if (this.proceduresStore.proceduresCounter) {
                if (status === "active") {
                    return this.proceduresStore.proceduresCounter.pending;
                } else if (status === "in-process") {
                    return this.proceduresStore.proceduresCounter.in_process;
                } else if (status === "canceled") {
                    return this.proceduresStore.proceduresCounter.canceled;
                } else if (status === "finished") {
                    return this.proceduresStore.proceduresCounter.complete;
                }
            }

            return 0;
        },

        getStatusColor(status) {
            return getProcedureStatusColor(status);
        },

        getStatusIcon(status) {
            return getProcedureStatusIcon(status);
        },

        filterProceduresList(filterStatus) {
            this.currentFilter = filterStatus;

            if (filterStatus < 6 && router.currentRoute.name !== "home") {
                router.push({ name: "home" });
            }

            if (filterStatus !== this.proceduresStore.filterStatus) {
                let request = procedureListRequest();
                request.userId = this.accountStore.user.id;
                request.status = filterStatus;
                request.limit = this.proceduresStore.pageLimit;

                this.getProceduresByUser(request);
            }
        },

        onResize() {
            if (window.innerWidth < 769) this.isMobile = true;
            else this.isMobile = false;
        },
    },
};
</script>

<style >

span.v-badge__badge {
    height: 15px !important;
    min-width: 15px !important;
}

.forma-titulo{
    width: 45px;
    height: 3px;
    background-color: #ff8400;
    position: absolute;
    margin-top: -1rem;
    margin-left: 1rem;
}
.theme--light.v-divider {
    border-color: #ff840033 !important;
}

.v-list-item__title, .v-list-item__subtitle{
    white-space: unset !important;
}

.v-btn:not(.v-btn--round).v-size--small{
    min-width: 130px;
}

.success_border{
    border: unset !important;
    color: #fff !important;
}

.btn-verde{
    background-color: #00a99d !important ;
}

.btn-azul{
    background-color: #0d65a5 !important ;
}

.font-size-sm{
    font-size: .8rem !important;
    color: black !important;
}

.v-tooltip__content{
    background-color: #fff5d3;
    color: grey;
    font-family: 'PoppinsRegular' !important;
}

.text-pantone{
    color: #ff8400 !important;
}

.text-family{
    font-family: 'PoppinsRegular' !important;
}

.bg_main .v-speed-dial {
    position: absolute;
}

#bg_main .v-btn--floating {
    position: relative;
}

.bg_main .v-list-item {
    padding: 0px !important;
}

.bg_main .v-list-item__content {
    padding: 0px !important;
}

.bg_main .v-list-item {
    min-height: auto !important;
}

.bg_main .dash_cards .v-avatar {
    border-radius: 5px 0px 0px 0px !important;
    width: 45px !important;
    height: 45px !important;
    min-width: 45px !important;
}

.bg_main .v-card {
    border-radius: 5px 5px 0px 0px !important;
}

.bg_main .v-list-item__content {
    border-radius: 0px 5px 0px 0px !important;
}

.bg_main .v-card__subtitle {
    /* text-align: center; */
    padding: 3px 16px 0px 16px !important;
}

.bg_main .sub_text_card {
    text-align: center;
    color: #fff;
    padding-top: 8px;
    font-size: 12px;
}

.bg_main .sub_text_card span {
    margin-left: 15px;
    margin-right: 15px;
}

.bg_main .ico_card {
    background-size: cover;
    width: 25px;
    height: 25px;
}

/*.bg_main .card_4 .ico_card {
    background-image: url("../assets/img/completado_c.png");
}*/

.bg_main .v-card__subtitle > span {
    color: #fff !important;
    padding-right: 10px;
}

.bg_main .v-chip {
    border-radius: 0px !important;
}

.v-chip .ico_status {
    background-size: cover;
    width: 15px;
    height: 15px;
    margin-right: 7px;
    margin-left: -4px;
}

.ico_item_action{
    width: 15px;
    height: 15px;
    margin-right: 5px;
    margin-left: -5px;
}

.flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 50%;
    height: 70px;
    font-weight: bold;
}

/*Dashboard mobile styles */
.mobile {
    width: 524px;
    margin: 0 auto;
    max-width: 100%;
    display: block;
}
.status_active_card_mobile {
    border-left: 6px solid var(--v-status_active-base);
}
.status_process_card_mobile {
    border-left: 6px solid var(--v-status_process-base);
}
.status_canceled_card_mobile {
    border-left: 6px solid var(--v-status_canceled-base);
}
.status_finished_card_mobile {
    border-left: 6px solid var(--v-status_finished-base);
}
.status-mobil {
    padding-top: 1px;
    padding-left: 27px !important;
    height: 20px;
    margin-bottom: 6px;
    font-size: 0.8rem;
}
.fecha-col-mobil {
    padding: 0 !important;
}
.fecha-mobil-label {
    margin-top: -2px;
    margin-bottom: 0;
    font-weight: 400;
    opacity: 0.6;
    width: 0.7rem;
}
.fecha-mobil {
    font-size: 0.7rem;
    font-weight: 400;
    margin-top: 3px;
}
.nombre-tramite-mobil {
    font-size: 1rem;
    padding: 12px 25px 0px 24px !important;
}

.procedure-stages-mobile {
    position: absolute;
    bottom: 0;
}
.pill-mobile {
    background-color: ghostwhite;
    padding: 0 0px 0px 5px;
    margin-left: 8px;
    margin-bottom: 10px;
    border-radius: 0 15px 15px 0;
}
.ico_progreso,
.ico_continuar {
    width: 12px;
    height: 12px;
}
.ico_history--chevron {
    font-size: 10px !important;
    margin-left: 0px !important;
}
.ico_history--eye {
    font-size: 11px !important;
    margin-right: 2px !important;
}
.v-btn:not(.v-btn--round).v-size--small {
    height: 26px;
    font-size: 0.6rem;
}
.btn-mobile {
    box-shadow: none;
    background-color: inherit !important;
    border-radius: 4px;
    border: none;
    margin: 4px 0 4px 0px;
    font-size: 0.7rem !important;
}

.btn-mobile:before {
    opacity: 0;
}
.mobile .v-card {
    height: 155px;
}
.v-btn.v-size--small {
    font-size: 0.6 rem;
}
.v-chip.v-size--small {
    border-radius: 12px !important;
    font-size: 10px;
    height: 24px;
}
.bg_main .v-card {
    border-radius: 5px !important;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

.v-list--three-line .v-list-item .v-list-item__content, .v-list-item--three-line .v-list-item__content{
    align-self: unset !important;
}


@media only screen and  (max-width: 770px ) {
    .forma-titulo{
        width: 35px;
        height: 3px;
        margin-left: 2rem;
    }

}
</style>
